export default __webpack_public_path__ + "static/media/headerlogo.1daac8cf.svg";